// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_9e1425b4d3--checkbox--Iw_6q","box":"_9e1425b4d3--box--LJe53","label":"_9e1425b4d3--label--S9Iv9"};